import { defaultAppTheme } from "../../../theme/defaultAppTheme";

export const dashboardTheme = {
  colors: {
    background: "#0d1117",
    backgroundAlt: "#161b22",
    surface: "#1c2128",
    surfaceElevated: "#21262d",
    cardBackground: "#161b22",
    cardBorder: "rgba(255, 255, 255, 0.08)",
    textPrimary: "#f0f6fc",
    textSecondary: "#8b949e",
    textMuted: "#6e7681",
    accent: defaultAppTheme.palette.primary.blue500,
    accentSoft: "rgba(110, 168, 255, 0.15)",
    accentBorder: "rgba(110, 168, 255, 0.35)",
    positive: "#3fb950",
    negative: "#f85149",
    skeleton: "rgba(255, 255, 255, 0.08)",
    skeletonHighlight: "rgba(255, 255, 255, 0.14)",
    divider: "rgba(255, 255, 255, 0.1)",
    chartLine: defaultAppTheme.palette.primary.blue600,
    chartFill: "rgba(100, 151, 232, 0.18)",
    chartGrid: "rgba(255, 255, 255, 0.06)",
    chartTick: "#8b949e",
    footerBackground: "#0d1117",
    footerBorder: "rgba(255, 255, 255, 0.08)",
  },
  radius: {
    card: "20px",
    metric: "16px",
    pill: "999px",
  },
  shadow: {
    card: "0 8px 32px rgba(0, 0, 0, 0.4)",
    metric: "0 2px 16px rgba(0, 0, 0, 0.25)",
  },
  spacing: {
    mobileSection: "0.625rem",
    mobileGap: "0.75rem",
    desktopGap: "1rem",
  },
  typography: {
    metricValue: "clamp(1.5rem, 2.5vw, 2rem)",
    metricLabel: "0.75rem",
    sectionTitle: "clamp(1rem, 1.4vw, 1.25rem)",
    body: "0.875rem",
  },
} as const;

export type DashboardTheme = typeof dashboardTheme;

export const getDashboardCardProps = (theme: DashboardTheme = dashboardTheme) => ({
  background: theme.colors.cardBackground,
  borderRadius: theme.radius.card,
  boxShadow: theme.shadow.card,
  border: `1px solid ${theme.colors.cardBorder}`,
  color: theme.colors.textPrimary,
});
